import styled from "styled-components"

import { COLOR } from "styles/style-constants"
import Button from "../button"
import Icon from "../icon"

export const WhiteBtn = styled(Button)`
  border: solid 1px ${COLOR.lightGray};
  &:hover,
  &:focus {
    background-color: ${COLOR.veryLightGray};
  }
  background-color: ${COLOR.white};
  color: ${COLOR.textBlack};
  transition: all, 0.5s;
  transform: background-color;
  &:disabled {
    transition: none;
    cursor: not-allowed;
    color: ${COLOR.lightGray};
    background: ${COLOR.white};
    border: 1px solid ${COLOR.lineGray};
  }
`

const WhiteButton = ({ leftIcon, children, ...rest }) => {
  return (
    <WhiteBtn small semiBold fontSize="16px" {...rest}>
      {/* NOTE: we should force set color here since in ios it will use blue as a text color
      *  instead of inheriting a expected color from parent
      */}
      {leftIcon && <Icon color={COLOR.textBlack} iconName="chevron-left" size="sm" />}
      {children}
    </WhiteBtn>
  )
}

export default WhiteButton
